import { render, staticRenderFns } from "./InventoryOperationsDashboard.vue?vue&type=template&id=7cf17261&scoped=true"
import script from "./InventoryOperationsDashboard.vue?vue&type=script&lang=js"
export * from "./InventoryOperationsDashboard.vue?vue&type=script&lang=js"
import style0 from "./InventoryOperationsDashboard.vue?vue&type=style&index=0&id=7cf17261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf17261",
  null
  
)

export default component.exports